export const checkParesButtonsMapper = (pointsOrder) => {
  return pointsOrder.map((pointOrder) => ({
    pointOrderId: pointOrder.id,
    parId: pointOrder.par.id,
    name: pointOrder.par.name,
  }));
};
